import React, { Component } from 'react';
import CustomButton from '../CustomButton';
import styles from './Registration.module.css';
import { authentication } from '../../../../shared/models/Authentication';
import { logVerifyEmail } from '../../../../shared/models/Analytics';
import { withRouter } from 'react-router-dom';
import { rwbApi } from '../../../../shared/apis/api';
import Loading from '../Loading';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import registerProfileFlow from '../../../../shared/utils/RegisterProfileFlow';


class RegisterWorkspaceAccessCode extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      showDialog: false,
      confirmationCode: new Array(projectConfig.verificationCodeLength).fill(''),
      errorMessage: '',
      userEmail:""
    };
  }

  logout = () => {
    authentication.deleteAuthentication();
    this.props.history.replace('/login');
  };

  verifyWorkSpace = () => {
    this.setState({errorMessage: ''});
    logVerifyEmail();
    const code = this.state.confirmationCode.join('');
    rwbApi
    .verifyWorkspaceAccessCode(code)
    .then((response) => {
      this.setState({errorMessage: ''});
      const firstScreen = registerProfileFlow.getFirstScreen();
      this.props.history.push(`/registration/${firstScreen.path}`);
    })
    .catch((err) => {
      this.setState({errorMessage: err.message});
    });
  }

  updateCode = (index, event) => {
    let code = this.state.confirmationCode;
    let value = event.target.value;
    // the user can press a new character after backspacing, keep the original character and prevent getting double characters per space
    if (value.length > 1) {
      value = value.charAt(0);
    }
    const currentValue = code[index];
    code[index] = value;
    // focus into next or previous input
    const newIndex = value !== '' ? index + 1 : index - 1;
    if (newIndex >= 0 && newIndex < projectConfig.verificationCodeLength) {
      if ((currentValue === '' && value !== '') || (currentValue === '' && value === ''))
        document.getElementById(`codeInput-${newIndex}`).focus();
    }
   this.setState({ confirmationCode: code });
  }

  handlePaste = (e) => {
    let pastedData = e?.clipboardData?.getData('Text').split('').slice(0,6);
    if (pastedData) {
      const lastCopiedIndex = pastedData.length - 1;
      while (pastedData.length < 6) pastedData.push('');
      this.setState({confirmationCode: pastedData});
      document.getElementById(`codeInput-${lastCopiedIndex}`).focus();
    }
  }

  handleBack = (index, event) => {
    // this function is called on key down and picks up all key events
    // if the key down is a "." prevent it from being added
    if (event.keyCode === 190) event.preventDefault();
    // backbutton
    if (event.keyCode === 8) {
      this.setState({errorMessage: ''});
      let code = this.state.confirmationCode;
      const inputValue = this.state.confirmationCode[index];
      if (inputValue === '' && index > 0) {
        document.getElementById(`codeInput-${index - 1}`).focus();
      }
      code[index] = '';
      this.setState({ confirmationCode: code });
    }
  }

  render() {
    const { isLoading } = this.state;

    return (
      <div className={styles.container}>
        <Loading size={100} color={'var(--white)'} loading={isLoading} />
        <div className={styles.headerContainer}>
          <h3 className="title">Workspace Access Code</h3>
         
        </div>
        <div className={styles.contentContainer}>
          <div>
           
            <div className={styles.verifyEmailContent}>
            
              <p>
              Enter your FitPros Access Code.
              </p>
        
            </div>
          </div>
          {projectConfig.verificationType === 'code' && (
            // verification code
            <div>
              {new Array(projectConfig.verificationCodeLength).fill(0).map((value, index) => {
                return (
                  <input value={this.state.confirmationCode[index]} autoFocus={index === 0} autoComplete='off'
                    id={`codeInput-${index}`} key={`codeInput-${index}`} type='text' className={styles.codeInput} max={9} min={0} maxLength={1}
                    onChange={(event) => this.updateCode(index, event)} onKeyDown={(event) => this.handleBack(index, event)} onPaste={this.handlePaste} />
                )
              })}
              <p className='errorMessage' style={{marginLeft: 5, marginTop: 5}}>{this.state.errorMessage}</p>
            </div>
          )}

          <div className={styles.buttonContainer}>
            <p className={styles.noEmail}>
            Your FitPros Access Code is provided by your employer. If you can't find it, please
             <br />
              <a className="link" href={`mailto:${projectConfig.supportEmail}`}>
                contact us
              </a>{' '}
              for help.
            </p>
            <CustomButton
              onClick={this.verifyWorkSpace}
              label={'NEXT'}
              disabled={this.state.confirmationCode.indexOf('') !== -1}
              buttonStyle={'primary'}
              customStyles={this.state.confirmationCode.indexOf('') !== -1 ? { opacity: '50%', cursor: 'initial' } : {}}
            />
            <CustomButton
              onClick={this.logout}
              label={'Not you? Back to login.'}
              buttonStyle={'secondary'}
            />
          </div>
        </div>
       
      </div>
    );
  }
}

export default withRouter(RegisterWorkspaceAccessCode);
